import React from 'react'
import { Dropdown } from '@billes/components'
import { connect } from '@cerebral/react'
import { state, signal } from 'cerebral/tags'
import { System } from 'components/Icons'
import { t } from '@billes/translator-client'
import alphabeticalSortASC from 'utils/alphabeticalSortASC'

const SystemSection = connect(
  {
    modules: state`app.user.modules`,
    changeModule: signal`app.changeModule`
  },
  ({ modules, changeModule }) => {
    if (!modules) {
      return null
    }
    const items = modules
      .reduce((acc, module) => {
        acc.push({
          label: t(`modules.${module.module}.name`),
          action: () => changeModule({ module: module.module })
        })
        return acc
      }, [])
      .sort((a, b) => alphabeticalSortASC(a.label, b.label))

    return (
      <div style={{ display: 'inline-block', paddingRight: 40 }}>
        <Dropdown
          icon={<System />}
          label={t('modules.switchModule')}
          items={items}
        />
      </div>
    )
  }
)

export default SystemSection



// WEBPACK FOOTER //
// ./src/components/Header/systemSection.js